import { useAppDispatch } from '@core/redux/hooks';
import {
  BreadcrumbItem,
  updateBreadcrumbs,
} from '@features/layout/store/layout.slice';
import { useEffect, useState } from 'react';

export function useBreadcrumbs(
  values: BreadcrumbItem[]
): React.Dispatch<React.SetStateAction<BreadcrumbItem[]>> {
  const dispatch = useAppDispatch();
  const [items, setItems] = useState(values);

  useEffect(() => {
    dispatch(updateBreadcrumbs(items));
  }, [items]);

  return setItems;
}
